import store from "./store";
export const events = {
  connect: () => {
    console.log("Socket connected");
  },

  UNREAD_ADMIN_CHATS_NUMBER: (data) => {
    store.dispatch("setCounterUnreadChats", data);
  },

  NEW_MESSAGE_EVENT: () => {},

  ALL_CHATS_EVENT: (data) => {
    store.commit("UPDATE_ROOMS", data);
  },

  ALL_MESSAGES_EVENT: (data) => {
    store.commit("UPDATE_MESSAGES", data);
  },

  WITHDRAW_REQUEST_EVENT: (number) => {
    store.dispatch("setCounterWaitingWithdraws", number);
  },

  EMPLOYEE_TO_VERIFY_EVENT: (number) => {
    store.dispatch("setWaitingToAcceptEmployeesCounter", number);
  },

  TASK_EVENT: (number) => {
    store.dispatch("setCounterTodoTasks", number);
  },
};

export const convertDataToJsonAndAddToken = (data) => {
  const token = window.localStorage.getItem("SAtoken");
  data.token = token;
  const json = JSON.stringify(data);
  return json;
};
